import { getImageUrl } from '../../config/Config';
import { useNavigate } from 'react-router-dom';
import CategoriesItemMenu from './CategoriesItemMenu';
import { Badge } from 'lucide-react';
import { NBadge } from 'nayan';
import { CONTENT_TYPES } from '../../services/DrawingsService.ts';

const CategoriesItem = (props: any) => {
  const { category } = props;
  const navigate = useNavigate();

  const viewItem = () => {
    navigate('/categories/' + category.uuid);
  };

  return (
    <div className="p-3 bg-card border-border border rounded cursor-pointer" onClick={viewItem}>
      <div className="h-[0px] overflow-hidden relative mb-3" style={{ paddingTop: '100%' }}>
        <img
          src={getImageUrl(category.file)}
          className={`rounded absolute top-0 left-0 w-full h-full ${category.content === CONTENT_TYPES.IMAGES ? 'object-contain' : 'object-cover'}`}
          alt={category.name}
        />
      </div>
      <div className="flex justify-between items-center mb-1">
        <div className="text-base flex-1 flex flex-row items-center line-clamp-1">
          <Badge className={`w-3 h-3 ${category.enabled === 'YES' ? 'text-primary fill-primary' : 'text-text fill-text'}`} />
          <div className="text-sm text-semibold ml-1 flex-1 line-clamp-1">{category.name}</div>
        </div>
        <CategoriesItemMenu category={category} />
      </div>
      <div className="text-sm leading-relaxed mb-2 line-clamp-1">{category.details}</div>
      <div className="mt-1">
        <NBadge size="XS">{category.content}</NBadge>
      </div>
    </div>
  );
};

export default CategoriesItem;
